import React, { useState } from 'react';
import { FlexRow, Modal } from 'styleguide';

import { MediaContent } from './MediaContent';
import { MediaToolbox } from './MediaToolbox';

interface Props {
  isModalOpen: boolean;
  toggleModal: () => void;
  onSelectImage: (url: string, dimensions?: { width: number; height: number }) => void;
}

export const MediaLibrary = ({ isModalOpen, toggleModal, onSelectImage }: Props) => {
  const [selectedImages, setSelectedImages] = useState<string[]>([]);
  const [isAiMode, toggleAiMode] = useState<boolean>(false);

  return (
    <Modal isOpen={isModalOpen} toggle={toggleModal} size="xl">
      <FlexRow>
        <MediaToolbox isAiMode={isAiMode} toggleAiMode={toggleAiMode} />
        <MediaContent
          isAiMode={false}
          selectedImages={selectedImages}
          setSelectedImages={(images: string[]) => setSelectedImages(images)}
          toggleModal={toggleModal}
          onSelectImage={onSelectImage}
        />
      </FlexRow>
    </Modal>
  );
};
